import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import { rest } from "lodash";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRestaurantMaster } from "../../store/restaurant/reducer";
import { REQUEST_DELETE_MASTER_RESTAURANT } from "../../store/restaurant/restaurantActionTypes";
interface RestaurantDeleteProps {
  restaurantData: any;
  isOpen: boolean;
  onClose: () => void;
}
const RestaurantDeleteConfirmation: React.FC<RestaurantDeleteProps> = ({
  isOpen,
  onClose,
  restaurantData,
}) => {
  const dispatch = useDispatch();
  const { masterRestaurant: events, busy, message } = useRestaurantMaster();
  const toast = useToast();
  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === restaurantData._id
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "selected data is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [restaurantData, events, onClose]);
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete selected data</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this Restaurant?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_RESTAURANT,
                payload: { _id: restaurantData._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon /> <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
export default RestaurantDeleteConfirmation;
